import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  position: absolute;
  align-items: center;
  justify-content: center;
  margin-bottom: 10px;
`;
